const InstallButton = () => {
  return null;
};

export default InstallButton;
